import * as React from "react";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import DynamicForm from "../../../../../../../core/presentations/DynamicForm";
import Validators from "../../../../../../../ui/helpers/validators";
import TopLabelFieldTemplate from "../../../../../../../ui/templates/fields/TopLabelFieldTemplate";
import VerticalFormTemplate from "../../../../../../../ui/templates/objects/VerticalFormTemplate";
import PrwcBasicButton from "../../../../../../../ui/widgets/custom/buttons/PrwcBasicButton";
import "./Location.scss";

const Location = (props: any) => {
  const { data } = props;
  const { t } = useTranslation();
  const submitButtonRef: any = useRef(null);
  const [formData, setFormData] = useState(data);

  const onChange = (formData: any) => {
    setFormData(formData);
  };

  const onSubmit = (data: any) => {
    console.log("data submitted ---");
    console.log(data);
  };

  const onError = (data: any) => {
    console.log("on error ---");
    console.log(data);
  };

  const handleOnSubmit = () => {
    // It is to submit form programmatically.
    submitButtonRef.current.click();
  };

  const formButtons = () => {
    return (
      <button ref={submitButtonRef} type="submit" className="hidden p-col-12" />
    );
  };

  const schema: any = {
    title: t("userCategories.label.general"),
    type: "object",
    properties: {
      locationName: {
        type: "string",
        title: t("userCategories.label.locationName"),
      },
      abbreviation: {
        type: "string",
        title: t("userCategories.label.abbreviation"),
      },
      description: {
        type: "string",
        title: t("userCategories.label.description"),
      },
    },
    required: ["locationName", "abbreviation"],
  };

  const validationSchema: any = {
    locationName: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "userCategories.validation.location.locationNameRequired",
        },
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 15);
          },
          messageKey:
            "userCategories.validation.location.locationNameMaxLength",
        },
      ],
    },
    abbreviation: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "userCategories.validation.location.abbreviationRequired",
        },
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 15);
          },
          messageKey:
            "userCategories.validation.location.abbreviationMaxLength",
        },
      ],
    },
    description: {
      validators: [
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 100);
          },
          messageKey: "userCategories.validation.location.descriptionMaxLength",
        },
      ],
    },
  };

  const uiSchema: any = {
    "ui:ObjectFieldTemplate": VerticalFormTemplate,
    locationName: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    abbreviation: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    description: {
      "ui:widget": "prwInputTextArea",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
  };

  return (
    <div className="location">
      <div className="px-4 overflow-y-auto content-height">
        <DynamicForm
          onChange={onChange}
          formData={formData}
          onSubmit={onSubmit}
          onError={onError}
          schema={schema}
          uiSchema={uiSchema}
          validationSchema={validationSchema}
          formButtons={() => formButtons()}
        ></DynamicForm>
      </div>
      <div className="flex justify-end px-2 border-t">
        <PrwcBasicButton
          onClick={handleOnSubmit}
          labelKey="users.action.save"
          className="w-24 h-8 my-1 bg-blue-700 border-blue-700 p-button-sm"
        ></PrwcBasicButton>
      </div>
    </div>
  );
};

export default Location;
